import { Group } from "../interfaces/IGroups";

/**
 * Hook do walidacji grup
 * Zapewnia spójne reguły walidacji dla nazwy grupy i liczby zawodników
 */
export const useGroupValidation = () => {
  const validateGroupName = (name: string): string | null => {
    if (!name || !name.trim()) {
      return "Nazwa grupy jest wymagana.";
    }
    if (name.trim().length > 50) {
      return "Nazwa grupy nie może mieć więcej niż 50 znaków.";
    }
    return null;
  };

  const validateParticipantCount = (participantIds: string[]): string | null => {
    const MAX_PARTICIPANTS = 50;
    if (participantIds.length > MAX_PARTICIPANTS) {
      return `Grupa nie może zawierać więcej niż ${MAX_PARTICIPANTS} zawodników.`;
    }
    return null;
  };

  const validateGroupData = (group: Partial<Group>): string[] => {
    const errors: string[] = [];
    const nameError = validateGroupName(group.name || "");
    if (nameError) errors.push(nameError);

    const countError = validateParticipantCount(group.participantIds || []);
    if (countError) errors.push(countError);

    return errors;
  };

  return { validateGroupName, validateParticipantCount, validateGroupData };
};

